<template lang="pug">
  .wrap
    .apps(v-loading="loading")
      .app(v-for='(license, index) in licenseList' :class='{ first: !index }')
        .app-header
          .app-name {{ license.app.name }}
          .app-remaining-seats {{ license.remainingSeats }}
          .app-tot-seats of {{ license.numOfLicenseSeats }} seats remaining

        el-alert.no-seats-left(v-if='!license.remainingSeats' :closable='false' title="No seats available." type="warning")
        .app-groups
          el-checkbox-group(v-model="internalValue")
            .app-group(v-for='groupEntry in license.licenseGroups' :key='groupEntry.group.id')
              el-checkbox(:label='groupEntry.id' :disabled='!license.remainingSeats')
                | {{ groupEntry.group.name }}
                el-tag.app-access-label(v-if='groupEntry.group.hasAppAccess' type="success") App access

</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      internalValue: [],
      appLicenses: []
    };
  },
  watch: {
    internalValue(value) {
      this.$emit("input", value);
    }
  },
  computed: {
    ...mapGetters("auth", "activeCompany"),
    licenseList() {
      return this.appLicenses.map(al => ({
        ...al,
        remainingSeats: al.numOfLicenseSeats - al.numUsers,
        licenseGroups: _.orderBy(
          al.licenseGroups,
          lg => lg.group.name.toLowerCase(),
          ["asc"]
        )
      }));
    }
  },
  methods: {
    ...mapActions({
      fetchAppLicenses: "appLicenses/fetchAppLicenses"
    }),
    loadData() {
      this.loading = true;
      this.fetchAppLicenses().then(data => {
        this.internalValue = [...this.value];
        this.appLicenses = data;
        this.loading = false;
      });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/mixins.scss";

.apps {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  @include MQ(L) {
    flex-direction: column;
  }
}

.app {
  flex-basis: calc(100% / 3 - 20px);
  min-height: auto;
  width: 100%;
  margin: 10px 0;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  @include MQ(L) {
    flex-basis: auto;
  }
}

:global(.el-checkbox-group) {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.app-header {
  background: #eee;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.app-name {
  font-weight: bold;
}

.app-remaining-seats {
  font-size: 30px;
  margin: 10px 0;
}

.app-groups {
  padding: 20px;
}

.app-group {
  margin: 10px 0;
  flex-basis: 50%;
  @include MQ(S) {
    flex-basis: 100%;
  }
}

.app-access-label {
  margin-left: 5px;
}

.no-seats-left {
  border-radius: 0;
}
</style>
